module.exports = __webpack_public_path__ + "media/src/images/arrowLink__arrow--dark-f3ae0e834ec631dff8e40f53712e603e.png";